import { useEffect, useState, useMemo } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { authAPI } from '../services/api'
import { EMAIL_SPAM_NOTE } from '../config/support'
import './Page.css'

export default function VerifyEmail() {
  const [searchParams] = useSearchParams()
  const token = useMemo(() => searchParams.get('token') || '', [searchParams])
  const { refreshUser } = useAuth()
  const [status, setStatus] = useState(token ? 'loading' : 'missing')
  const [message, setMessage] = useState('')

  useEffect(() => {
    if (!token) {
      setStatus('missing')
      return
    }
    let cancelled = false
    ;(async () => {
      try {
        const r = await authAPI.verifyEmail(token)
        if (!cancelled) {
          setStatus('ok')
          setMessage(r?.message || 'Email verified.')
          await refreshUser()
        }
      } catch (e) {
        if (!cancelled) {
          setStatus('err')
          setMessage(e.message || 'Verification failed')
        }
      }
    })()
    return () => {
      cancelled = true
    }
  }, [token, refreshUser])

  return (
    <div className="page-container">
      <div className="dashboard-card" style={{ maxWidth: 440, margin: '2rem auto' }}>
        <h1 style={{ marginTop: 0 }}>Email verification</h1>
        {status === 'missing' && (
          <p style={{ color: 'var(--text-secondary)' }}>
            Missing token. Open the link from your verification email, or paste the token below. {EMAIL_SPAM_NOTE}
          </p>
        )}
        {status === 'loading' && <p>Verifying…</p>}
        {status === 'ok' && <p style={{ color: 'var(--success, #2d8a4e)' }}>{message}</p>}
        {status === 'err' && <p style={{ color: 'var(--error, #c44)' }}>{message}</p>}
        <p style={{ marginTop: '1.5rem' }}>
          <Link to="/">← Back to home</Link>
          {' · '}
          <Link to="/dashboard">Dashboard</Link>
        </p>
      </div>
    </div>
  )
}
